export default function generateAnimationName(id) {
  return "k" + id;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateAnimationName.js
// module id = 695
// module chunks = 0